import { DashboardScreen } from '../features/dashboard/DashboardScreen'

export function DashboardPage() {
  return <DashboardScreen />
}
